// extracted by mini-css-extract-plugin
export default {"container":"styles_container__aF5z4","loading":"styles_loading__9ozN-"};